import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Our Eggs Guarantee</title>
                    <meta name="description" content="At A&W, all our eggs are farmed right here in Canada, from hens fed a fully vegetarian diet without animal by-products." />
                </Helmet>
            :
                <Helmet>
                    <title>La garantie sur nos œufs</title>
                    <meta name="description" content="Chez A&W, nos œufs proviennent d’élevages canadiens végétariens où les poules sont nourries de manière exclusivement végétarienne, sans aucun sous-produit animal." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;